import querystring from 'querystring';

const parse = (str, ...rest) => {
  return querystring.parse(str.slice(1, str.length), ...rest);
};

const substitute = (str, paramName, newValue) => {
  const strParsed = parse(str);

  strParsed[paramName] = newValue;

  return querystring.stringify(strParsed);
};

const deleteParam = (str, paramName) => {
  const strParsed = parse(str);

  delete strParsed[paramName];

  return querystring.stringify(strParsed);
};

export default {
  ...querystring,
  parse,
  substitute,
  deleteParam
};
